import { Phone, Calendar } from "lucide-react";
import { useState } from "react";

const FloatingContactIcons = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* WhatsApp */}
      <a
        href="https://wa.me/254111653233"
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 bg-logo-gold-gradient border border-logo-gold text-[#3A2A0D] rounded-full shadow-logo-gold flex items-center justify-center transition-all duration-300 hover:scale-110 hover:opacity-95"
        title="WhatsApp"
      >
        <img src="/whatsapp_icon-.png" alt="WhatsApp" className="w-10 h-10" />
      </a>

      {/* Call */}
      <a
        href="tel:+254111653233"
        className="w-14 h-14 bg-logo-gold-gradient border border-logo-gold text-[#3A2A0D] rounded-full shadow-logo-gold flex items-center justify-center transition-all duration-300 hover:scale-110 hover:opacity-95"
        title="Call"
      >
        <Phone className="w-6 h-6" />
      </a>

      {/* Calendar */}
      <a
        href="/contact"
        className="w-14 h-14 bg-logo-gold-gradient border border-logo-gold text-[#3A2A0D] rounded-full shadow-logo-gold flex items-center justify-center transition-all duration-300 hover:scale-110 hover:opacity-95"
        title="Book Appointment"
      >
        <Calendar className="w-6 h-6" />
      </a>
    </div>
  );
};

export default FloatingContactIcons;
